import { render, staticRenderFns } from "./InterProcessConfigurationPage.vue?vue&type=template&id=3b43a2c3&"
import script from "./InterProcessConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./InterProcessConfigurationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b43a2c3')) {
      api.createRecord('3b43a2c3', component.options)
    } else {
      api.reload('3b43a2c3', component.options)
    }
    module.hot.accept("./InterProcessConfigurationPage.vue?vue&type=template&id=3b43a2c3&", function () {
      api.rerender('3b43a2c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/InterProcess/InterProcessConfigurationPage.vue"
export default component.exports